<!-- <footer class="-tw-mt-40">
  <div class=" tw-bg-black tw-h-40 tw-rounded-t-full "></div>
  <div class=" tw-bg-black tw-text-white">
    <div class="uw-container uw-w-wide tw-flex tw-flex-wrap tw-justify-between tw-items-end tw-gap-2 tw-p-2 tw-text-sm">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <a [routerLink]="[ '/about' ]">About</a>
        <a [routerLink]="[ '/contact' ]">Contact Us</a>
        <a [routerLink]="[ '/terms' ]">Terms, Conditions & Privacy Policy</a>
       
      </div>
      <div class="tw-flex tw-flex-col tw-gap-1">
        <brt-payment-logos></brt-payment-logos>

      </div>
      <div class="tw-flex tw-flex-col tw-gap-1">
        <div class="tw-text-nowrap">
          Powered by <a target="_blank" href="https://briteat.co.uk">Brit Eat!</a>
        </div>
      </div>
    </div>
  </div>
  <div class="tw-flex tw-bg-[--palette-brit-red] tw-text-white tw-h-5">
    <img src="assets/images/logo/briteat-logo-smile.svg" alt="BritEat platform" class="tw-h-4 tw-mx-auto">
  </div>
</footer> -->

<footer>
  <div class="tw-container tw-px-4">
    <div class="tw-flex tw-flex-col">
      <a [routerLink]="[ '/about' ]">About</a>
      <a [routerLink]="[ '/contact' ]">Contact Us</a>
      <a [routerLink]="[ '/terms' ]">Terms, Conditions & Privacy Policy</a>
    </div>
    <div>
      <brt-payment-logos></brt-payment-logos>
    </div>
  </div>
  <hr class="tw-my-4 tw-opacity-50" />
  <div class="tw-container tw-px-4">
    @if(copyright){
    <p>{{copyright}}</p>
    } @else {
    <p>&copy; 2024 <a target="_blank" href="https://briteat.co.uk">Brit Eat!</a></p>
    }
    <button type="button" class="tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm tw-underline tw-cursor-pointer"
      [disabled]="refreshing" (click)="refreshApp()"
      title="Check for updates and refresh the app">
      <i class="pi" [ngClass]="refreshing ? 'pi-spin pi-spinner' : 'pi-refresh'"></i>
      Version {{version}} · {{refreshing ? 'Updating...' : 'Refresh to update'}}
    </button>
  </div>
</footer>
